import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { createAdminUser } from '@/utils/createAdminUser';
import { toast } from 'sonner';
import { useAuth } from '@/contexts/auth/AuthContext';

export default function CreateAdminUser() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isCreating, setIsCreating] = useState(false);
  const { isAdmin } = useAuth();

  const handleCreateAdmin = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!isAdmin()) {
      toast.error('Only administrators can create admin users');
      return;
    }
    
    setIsCreating(true);
    
    try {
      await createAdminUser(email, password);
      toast.success(`Admin user ${email} created successfully`);
      setEmail('');
      setPassword('');
    } catch (error: any) {
      toast.error(`Failed to create admin user: ${error.message}`);
    } finally {
      setIsCreating(false);
    }
  };

  if (!isAdmin()) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Access Denied</CardTitle>
          <CardDescription>
            You must be an administrator to access this feature.
          </CardDescription>
        </CardHeader>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Create Admin User</CardTitle>
        <CardDescription>
          Add a new administrator account to the system
        </CardDescription>
      </CardHeader>
      <form onSubmit={handleCreateAdmin}>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <label htmlFor="email" className="text-sm font-medium">Email</label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@example.com"
              required
            />
          </div>
          <div className="space-y-2">
            <label htmlFor="password" className="text-sm font-medium">Password</label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Secure password"
              required
              minLength={8}
            />
          </div>
        </CardContent>
        <CardFooter>
          <Button type="submit" disabled={isCreating}>
            {isCreating ? 'Creating...' : 'Create Admin User'}
          </Button>
        </CardFooter>
      </form>
    </Card>
  );
}
